import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44473465")

_pushScopeId("data-v-44473465")
const _hoisted_1 = { class: "p-mb-2" }
const _hoisted_2 = { class: "card card-status card-status-title p-mb-2 p-ml-2" }
const _hoisted_3 = { class: "card card-status card-status-description p-ml-2" }
const _hoisted_4 = { class: "p-pt-2" }
const _hoisted_5 = { class: "p-col-12" }
const _hoisted_6 = { class: "card card-info-title p-mb-1 p-ml-2" }
const _hoisted_7 = {
  key: 0,
  class: "p-col-12"
}
const _hoisted_8 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_9 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_10 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_11 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_12 = {
  key: 0,
  class: "card card-inner-text p-mb-1 p-ml-2"
}
const _hoisted_13 = {
  key: 1,
  class: "card card-inner-text p-mb-1 p-ml-2"
}
const _hoisted_14 = {
  key: 2,
  class: "card card-inner-text p-mb-1 p-ml-2"
}
const _hoisted_15 = { class: "p-col-12" }
const _hoisted_16 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_17 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_18 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_19 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_20 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_21 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_22 = {
  key: 1,
  class: "card card-inner-text p-mb-1 p-ml-2"
}
const _hoisted_23 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_24 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_25 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_26 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_27 = {
  key: 1,
  class: "p-col-12"
}
const _hoisted_28 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_29 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_30 = {
  key: 2,
  class: "p-col-12"
}
const _hoisted_31 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_32 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_33 = {
  key: 3,
  class: "p-col-12"
}
const _hoisted_34 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_35 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_36 = { class: "p-col-12" }
const _hoisted_37 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_38 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_39 = { class: "p-col-12" }
const _hoisted_40 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_41 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_42 = {
  key: 4,
  class: "p-col-12"
}
const _hoisted_43 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_44 = { class: "card card-inner-text p-mb-1 p-ml-2" }
const _hoisted_45 = { class: "p-col-12" }
const _hoisted_46 = { class: "card card-inner-title p-mb-2 p-ml-2" }
const _hoisted_47 = { class: "card card-inner-text p-mb-1 p-ml-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: _ctx.getCssClassBox(_ctx.cardStatus)
    }, [
      _createVNode("div", {
        class: _ctx.getCssClass(_ctx.cardStatus)
      }, [
        _createVNode("p", _hoisted_2, _toDisplayString(_ctx.cardStatusTitle), 1),
        _createVNode("p", _hoisted_3, _toDisplayString(_ctx.cardStatusDescription), 1)
      ], 2),
      _createVNode("div", {
        class: ["row", _ctx.getCssClassDescriptionContainer(_ctx.cardStatus)]
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: _ctx.getCssClassToggler(_ctx.cardStatus)
          }, null, 2)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.cardInfoTitle), 1)
        ]),
        (_ctx.initiatorName != null && _ctx.initiatorName != undefined && _ctx.initiatorName != '')
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.initiatorTitle), 1),
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.initiatorName), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: "p-col-12",
          style: _ctx.getCssDebtorData(_ctx.haveDebtorAccount)
        }, [
          _createVNode("p", _hoisted_10, _toDisplayString(_ctx.payerDetailTitle), 1),
          _createVNode("p", _hoisted_11, _toDisplayString(_ctx.payerCpf), 1),
          (_ctx.payerName != null && _ctx.payerName != undefined && _ctx.payerName != '')
            ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.payerName), 1))
            : _createCommentVNode("", true),
          (_ctx.payerBranch != null && _ctx.payerBranch != undefined && _ctx.payerBranch != '')
            ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.payerBranch), 1))
            : _createCommentVNode("", true),
          (_ctx.payerCc != null && _ctx.payerCc != undefined && _ctx.payerCc != '')
            ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(_ctx.payerCc), 1))
            : _createCommentVNode("", true)
        ], 4),
        _createVNode("div", _hoisted_15, [
          _createVNode("p", _hoisted_16, _toDisplayString(_ctx.beneficiaryDetailTitle), 1),
          _createVNode("p", _hoisted_17, _toDisplayString(_ctx.beneficiaryCnpj), 1),
          _createVNode("p", _hoisted_18, _toDisplayString(_ctx.beneficiaryName), 1),
          (_ctx.localInstrument == 'MANU')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("p", _hoisted_19, _toDisplayString(_ctx.beneficiaryBankLabel) + " " + _toDisplayString(_ctx.beneficiaryBankCode), 1),
                _createVNode("p", _hoisted_20, _toDisplayString(_ctx.beneficiaryAggLabel) + " " + _toDisplayString(_ctx.beneficiaryAgg), 1),
                _createVNode("p", _hoisted_21, _toDisplayString(_ctx.beneficiaryAccount), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.localInstrument == 'DICT' || _ctx.localInstrument == 'INIC')
            ? (_openBlock(), _createBlock("p", _hoisted_22, _toDisplayString(_ctx.beneficiaryPixLabel) + " " + _toDisplayString(_ctx.beneficiaryPixValue), 1))
            : _createCommentVNode("", true),
          (_ctx.localInstrument == 'QRDN')
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _createVNode("p", _hoisted_23, _toDisplayString(_ctx.beneficiaryQRDinLabel), 1),
                _createVNode("p", _hoisted_24, _toDisplayString(_ctx.beneficiaryPixLabel) + " " + _toDisplayString(_ctx.beneficiaryPixValue), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.localInstrument == 'QRES')
            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                _createVNode("p", _hoisted_25, _toDisplayString(_ctx.beneficiaryQREstLabel), 1),
                _createVNode("p", _hoisted_26, _toDisplayString(_ctx.beneficiaryPixLabel) + " " + _toDisplayString(_ctx.beneficiaryPixValue), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.consentCreatorName != null && _ctx.consentCreatorName != undefined && _ctx.consentCreatorName != '')
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _createVNode("p", _hoisted_28, _toDisplayString(_ctx.consentCreatorLabel), 1),
              _createVNode("p", _hoisted_29, _toDisplayString(_ctx.consentCreatorName), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.scheduledDate)
          ? (_openBlock(), _createBlock("div", _hoisted_30, [
              _createVNode("p", _hoisted_31, _toDisplayString(_ctx.initiationDateTitle), 1),
              _createVNode("p", _hoisted_32, _toDisplayString(_ctx.initiationDate), 1)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_33, [
              _createVNode("p", _hoisted_34, _toDisplayString(_ctx.scheduledDateTitle), 1),
              _createVNode("p", _hoisted_35, _toDisplayString(_ctx.scheduledDate), 1)
            ])),
        _createVNode("div", _hoisted_36, [
          _createVNode("p", _hoisted_37, _toDisplayString(_ctx.valueTitle), 1),
          _createVNode("p", _hoisted_38, _toDisplayString(_ctx.value), 1)
        ]),
        _createVNode("div", _hoisted_39, [
          _createVNode("p", _hoisted_40, _toDisplayString(_ctx.paymentFormTitle), 1),
          _createVNode("p", _hoisted_41, _toDisplayString(_ctx.paymentForm), 1)
        ]),
        (_ctx.payFee != null && _ctx.payFee != undefined && _ctx.payFee != '')
          ? (_openBlock(), _createBlock("div", _hoisted_42, [
              _createVNode("p", _hoisted_43, _toDisplayString(_ctx.payFeeTitle), 1),
              _createVNode("p", _hoisted_44, _toDisplayString(_ctx.payFee), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_45, [
          _createVNode("p", _hoisted_46, _toDisplayString(_ctx.consentIDTitle), 1),
          _createVNode("p", _hoisted_47, _toDisplayString(_ctx.consentID), 1)
        ])
      ], 2)
    ], 2)
  ]))
})